module.exports = __webpack_public_path__ + "a49eefba820db1ad2153ca69743f043f.pdf";